import { Button, ButtonVariants } from '@shared/components/button/Button';
import { useServiceSearchParams } from '../../hooks/useServiceSearchParams';
import { useWaitListContext } from './state/WaitListContext';
import styles from './WaitList.scss';
import { WaitListEntryCard } from './WaitListEntryCard';

export const WaitList = () => {
  const { openAddToWaitListDrawer, openWaitListEntryDrawer } =
    useServiceSearchParams();

  const { setSelectedWaitListEntryIndex, waitListEntries } =
    useWaitListContext();

  const handleWaitListEntryCardClick = (index: number) => {
    setSelectedWaitListEntryIndex(index);
    openWaitListEntryDrawer(index);
  };

  return (
    <>
      <Button
        className={styles.addToWaitListButton}
        label="Add to Waitlist"
        variant={ButtonVariants.Secondary}
        onClick={openAddToWaitListDrawer}
      />

      <ul aria-label="wait list" className={styles.list}>
        {waitListEntries.map((waitListEntry, index) => (
          <WaitListEntryCard
            index={index}
            key={waitListEntry.id}
            onClick={() => handleWaitListEntryCardClick(index)}
            waitListEntry={waitListEntry}
          />
        ))}
      </ul>
    </>
  );
};
